// In TypeScript, flat can be typed as function flat<T>(arr: T[][]): T[]
// because it flattens one level of nested arrays,
// returning a single array of the inner type.
// export function flat<T>(arr: T[][]):T[] { return arr.reduce((a, b) => a.concat(b), []); }
interface FlatFunction {
  <T>(arr: T[][]): T[];
}
export const flat: FlatFunction = (arr) => arr.reduce((x,y)=> x.concat(y),[]);